import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { configureContactForm } from '@shared/contact-form'
import App from './App'
import './index.css'
import '@shared/contact-form/styles.css'
import './i18n'

// Configure the shared ContactForm for cross-origin use.
// The landing lives on verdevercelli.it; the backend is on avmg.it.
// credentials 'omit' because the form endpoints don't need auth and
// the session cookie isn't cross-origin shareable anyway.
configureContactForm({
  backendBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://avmg.it',
  credentials: 'omit',
})

const rootEl = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)
// Prerendered sites stamp the path they rendered; hydrate only when it is THIS
// path (token pages and unknown routes hit the nginx index.html fallback, whose
// markup belongs to another page — clear it and client-render instead).
const prerenderedPath = rootEl.dataset.prerenderedPath
const herePath = window.location.pathname.replace(/\/?$/, '/')
if (prerenderedPath && prerenderedPath === herePath) {
  hydrateRoot(rootEl, app)
} else {
  if (prerenderedPath) rootEl.replaceChildren()
  createRoot(rootEl).render(app)
}
